import DatadogUtil from 'performance/DatadogUtil';

/*
This function is here to be used as a `hanlder` value for routes where we want the front-end to return
nothing at all.
*/
export default function noOpRoute(): void {
  /*
  The invocation of the `DatadogUtil.startRUMView` effectively signals a "page change" in the RUM UI; without
  it, switching to `noOpRoute` routes would still count as the previous page. (Credit to Anuj Das for this
  explanation.)
  */
  DatadogUtil.startRUMView('noop_route');
}
